// src/pages/Legal.jsx
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const COMPANY = {
  name: "Zentra Group SpA",
  website: "https://zentragroup.cl/",
  email: "soporte@zentragroup.cl",
  phone: "+569 68585106",
  legalName: "Zentra Group SpA",
  rut: "78.160.525-5",
  updatedAt: "Mayo 2026",
};

const termsSections = [
  {
    id: "titular",
    title: "1. Identificación del titular del sitio",
    content: [
      `El sitio web ${COMPANY.website} es administrado por ${COMPANY.name}.`,
      `Razón social: ${COMPANY.legalName}`,
      `RUT: ${COMPANY.rut}`,
      `Correo electrónico de contacto: ${COMPANY.email}`,
      `Teléfono / WhatsApp: ${COMPANY.phone}`,
    ],
  },
  {
    id: "objeto",
    title: "2. Objeto del sitio web",
    content: [
      "Zentra Group pone a disposición de sus visitantes un sitio web informativo y comercial orientado a presentar sus servicios tecnológicos.",
      "Entre los servicios ofrecidos se encuentran el desarrollo de sistemas web y plataformas personalizadas, soluciones POS para ventas, inventario, boletas y gestión operativa, servicios GPS, monitoreo de flotas, integraciones, automatización de procesos, soporte y asesoría tecnológica.",
      "La información publicada en el sitio tiene carácter referencial y puede ser complementada mediante cotizaciones, propuestas comerciales, contratos, anexos, órdenes de compra u otros documentos aceptados por las partes.",
    ],
  },
  {
    id: "uso",
    title: "3. Uso permitido del sitio",
    content: [
      "El usuario se compromete a utilizar el sitio web de forma lícita, correcta y de acuerdo con estos Términos y Condiciones, la legislación vigente y las buenas costumbres.",
      "Queda prohibido utilizar el sitio con fines fraudulentos, ilegales o que puedan afectar derechos de terceros.",
      "También se prohíbe intentar acceder sin autorización a sistemas, bases de datos, formularios, paneles privados o infraestructura tecnológica de Zentra Group.",
      "No está permitido introducir virus, malware, scripts maliciosos o cualquier elemento que pueda dañar, alterar o interferir con el funcionamiento del sitio.",
      "Zentra Group podrá limitar, suspender o bloquear el acceso al sitio cuando detecte usos indebidos, intentos de vulneración o conductas contrarias a estos términos.",
    ],
  },
  {
    id: "cotizaciones",
    title: "4. Información de servicios y cotizaciones",
    content: [
      "Los servicios ofrecidos por Zentra Group pueden variar según los requerimientos del cliente, alcance del proyecto, funcionalidades solicitadas, integraciones, plazos, soporte, licencias, hosting, infraestructura, cantidad de usuarios, volumen de datos y otros factores técnicos o comerciales.",
      "Salvo que se indique expresamente lo contrario, los precios, planes, descripciones, imágenes, ejemplos o referencias publicados en el sitio son de carácter informativo y no constituyen una oferta final vinculante.",
      "Toda contratación deberá ser confirmada mediante una cotización, propuesta, contrato, orden de compra, correo electrónico de aceptación u otro medio equivalente acordado por las partes.",
    ],
  },
  {
    id: "contratacion",
    title: "5. Contratación de servicios",
    content: [
      "La contratación de servicios podrá formalizarse mediante aceptación escrita de una cotización o propuesta comercial, firma de contrato o anexo de servicio, orden de compra aceptada, pago inicial, abono, activación del servicio o confirmación expresa por correo electrónico, WhatsApp u otro medio verificable.",
      "El alcance definitivo del servicio será el indicado en la propuesta o contrato correspondiente.",
      "Cualquier funcionalidad, modificación, integración o requerimiento adicional no incluido expresamente podrá ser cotizado por separado.",
    ],
  },
  {
    id: "pagos",
    title: "6. Pagos, facturación y suspensión de servicios",
    content: [
      "Las condiciones de pago, valores, periodicidad, vencimientos, descuentos, reajustes, métodos de pago y documentos tributarios serán informados en la cotización, propuesta o contrato respectivo.",
      "En caso de servicios recurrentes, mensualidades, mantenciones, soporte, plataformas, GPS, licencias o similares, el cliente deberá pagar dentro de los plazos acordados.",
      "El incumplimiento de pago podrá facultar a Zentra Group para suspender temporalmente el servicio, restringir accesos, detener soporte o poner término al servicio, previa comunicación al cliente, salvo que las partes hayan acordado condiciones distintas por escrito.",
      "Los pagos realizados por servicios personalizados, desarrollos a medida, configuraciones, instalaciones, licencias, integraciones o trabajos ya ejecutados no serán reembolsables, salvo acuerdo expreso entre las partes o disposición legal aplicable.",
    ],
  },
  {
    id: "plazos",
    title: "7. Plazos de entrega y ejecución",
    content: [
      "Los plazos informados para desarrollo, implementación, activación, soporte o entrega de servicios son estimativos, salvo que se indique expresamente un plazo obligatorio en la propuesta o contrato.",
      "Los plazos podrán variar por demora del cliente en entregar información, accesos, contenidos, imágenes, credenciales, documentación o aprobaciones.",
      "También podrán variar por cambios de alcance, requerimientos adicionales, dependencia de terceros, hosting, APIs, pasarelas de pago, servicios externos, contingencias técnicas, casos fortuitos o fuerza mayor.",
      "Zentra Group no será responsable por retrasos originados por falta de colaboración del cliente o por fallas de terceros externos a la empresa.",
    ],
  },
  {
    id: "cliente",
    title: "8. Obligaciones del cliente",
    content: [
      "El cliente se compromete a entregar información veraz, completa y actualizada.",
      "También deberá proporcionar oportunamente accesos, contenidos, datos, logos, imágenes, textos, credenciales o antecedentes necesarios para ejecutar el servicio.",
      "El cliente deberá revisar y aprobar entregables dentro de los plazos acordados, resguardar sus credenciales, usuarios y contraseñas, y usar las plataformas o sistemas entregados conforme a la ley y al contrato respectivo.",
      "El cliente será responsable del contenido, datos, información comercial, productos, precios, documentos, imágenes o materiales que entregue o cargue en los sistemas desarrollados o administrados por Zentra Group.",
    ],
  },
  {
    id: "soporte",
    title: "9. Soporte y mantención",
    content: [
      "El soporte técnico, mantención, actualizaciones, respaldo de información, monitoreo, asistencia remota, capacitaciones o mejoras estarán incluidos únicamente cuando hayan sido contratados o indicados expresamente en la propuesta comercial.",
      "Salvo acuerdo distinto, el soporte no incluye nuevas funcionalidades no contempladas inicialmente, cambios de diseño o estructura solicitados después de la aprobación, corrección de errores provocados por intervención de terceros, problemas derivados de hosting, dominios, correos, plugins, APIs, dispositivos o servicios externos no administrados directamente por Zentra Group, ni recuperación de accesos o información perdida por mal uso del cliente.",
    ],
  },
  {
    id: "terceros",
    title: "10. Servicios de terceros",
    content: [
      "Algunos servicios pueden depender de plataformas, herramientas o proveedores externos, tales como hosting, dominios, correos electrónicos, servicios GPS, APIs, pasarelas de pago, sistemas de facturación, mapas, WhatsApp, redes sociales, certificados digitales, servicios del SII u otros.",
      "Zentra Group no será responsable por caídas, modificaciones, restricciones, errores, cambios de precios, interrupciones, bloqueos o decisiones comerciales adoptadas por dichos terceros.",
      "Cuando corresponda, el cliente deberá aceptar y cumplir los términos y condiciones de esos proveedores externos.",
    ],
  },
  {
    id: "propiedad",
    title: "11. Propiedad intelectual",
    content: [
      "Todos los contenidos del sitio web, incluyendo textos, diseños, estructura visual, gráficos, logotipos, imágenes, interfaces, código, estilos, elementos de marca y material comercial, son de propiedad de Zentra Group o de sus respectivos titulares.",
      "Queda prohibida su reproducción, distribución, modificación, publicación, venta, explotación comercial o uso no autorizado.",
      "En proyectos personalizados, la titularidad de los entregables, código fuente, licencias, diseños, documentación, bases de datos o componentes se regulará según lo indicado en la propuesta o contrato respectivo.",
      "Si no existe acuerdo escrito, Zentra Group conservará la propiedad sobre metodologías, componentes reutilizables, librerías propias, estructuras base, know-how, plantillas y herramientas desarrolladas previamente.",
    ],
  },
  {
    id: "confidencialidad",
    title: "12. Confidencialidad",
    content: [
      "Zentra Group y el cliente se comprometen a mantener reserva sobre la información técnica, comercial, financiera, estratégica, operacional o confidencial que conozcan con ocasión de una cotización, negociación, implementación o prestación de servicios.",
      "Esta obligación no aplicará respecto de información que sea pública, que haya sido conocida legítimamente por terceros, que deba revelarse por obligación legal o que haya sido autorizada expresamente por la parte titular de dicha información.",
    ],
  },
  {
    id: "responsabilidad",
    title: "13. Limitación de responsabilidad",
    content: [
      "Zentra Group no será responsable por daños derivados del uso indebido del sitio o de los servicios por parte del usuario o cliente.",
      "Tampoco será responsable por decisiones tomadas por el usuario con base en información referencial publicada en el sitio, fallas o restricciones de servicios externos, pérdida de información causada por negligencia del cliente, intervención de terceros o falta de respaldos contratados.",
      "Nada de lo anterior limitará los derechos que la ley reconoce a consumidores o clientes cuando corresponda.",
    ],
  },
  {
    id: "ley",
    title: "14. Legislación aplicable y resolución de controversias",
    content: [
      "Estos Términos y Condiciones se rigen por las leyes de la República de Chile.",
      "Cualquier dificultad, controversia o reclamo derivado del uso del sitio web o de la contratación de servicios será resuelto preferentemente mediante comunicación directa y de buena fe entre las partes.",
      "En caso de no alcanzar acuerdo, las partes podrán recurrir a los mecanismos legales correspondientes y a los tribunales competentes de la República de Chile.",
    ],
  },
];

const privacySections = [
  {
    id: "responsable",
    title: "1. Responsable del tratamiento",
    content: [
      `El responsable del tratamiento de los datos personales es ${COMPANY.name}.`,
      `Razón social: ${COMPANY.legalName}`,
      `RUT: ${COMPANY.rut}`,
      `Domicilio: ${COMPANY.address}`,
      `Correo de contacto: ${COMPANY.email}`,
    ],
  },
  {
    id: "datos",
    title: "2. Datos que podemos recopilar",
    content: [
      "Nombre y apellido.",
      "Correo electrónico.",
      "Número de teléfono o WhatsApp.",
      "Empresa u organización.",
      "RUT, cuando sea necesario para cotización, facturación o contratación.",
      "Información contenida en mensajes, formularios o solicitudes.",
      "Datos técnicos básicos de navegación, como dirección IP, tipo de dispositivo, navegador, fecha y hora de acceso, cuando sean recopilados por herramientas del sitio o del hosting.",
    ],
  },
  {
    id: "finalidades",
    title: "3. Finalidades del tratamiento",
    content: [
      "Responder consultas y solicitudes de información.",
      "Preparar cotizaciones o propuestas comerciales.",
      "Coordinar reuniones, demostraciones o soporte.",
      "Prestar servicios contratados.",
      "Gestionar clientes, pagos, facturación y soporte.",
      "Mejorar el sitio web, la experiencia de usuario y la seguridad.",
      "Cumplir obligaciones legales, tributarias o contractuales.",
      "Enviar comunicaciones comerciales relacionadas con los servicios de Zentra Group, cuando corresponda.",
    ],
  },
  {
    id: "base",
    title: "4. Base de tratamiento",
    content: [
      "El tratamiento se realizará en virtud del consentimiento entregado por el usuario al enviar sus datos, la ejecución de medidas precontractuales o contractuales, el cumplimiento de obligaciones legales y el interés legítimo de Zentra Group en administrar sus servicios, comunicaciones y seguridad.",
    ],
  },
  {
    id: "conservacion",
    title: "5. Conservación de los datos",
    content: [
      "Los datos serán conservados durante el tiempo necesario para cumplir las finalidades indicadas, responder solicitudes, mantener relaciones comerciales, cumplir obligaciones legales o respaldar la prestación de servicios.",
    ],
  },
  {
    id: "terceros-privacidad",
    title: "6. Comunicación a terceros",
    content: [
      "Zentra Group no venderá los datos personales de sus usuarios.",
      "Los datos podrán ser compartidos únicamente cuando sea necesario con proveedores tecnológicos, hosting, correo electrónico, herramientas de soporte, sistemas de facturación, plataformas de comunicación, asesores contables o legales, o autoridades competentes, siempre en la medida necesaria para cumplir las finalidades indicadas o una obligación legal.",
    ],
  },
  {
    id: "seguridad",
    title: "7. Seguridad de la información",
    content: [
      "Zentra Group adoptará medidas razonables de seguridad técnica y organizacional para proteger los datos personales contra acceso no autorizado, pérdida, alteración, uso indebido o divulgación no autorizada.",
      "No obstante, ningún sistema informático o transmisión por internet puede garantizar seguridad absoluta.",
    ],
  },
  {
    id: "derechos",
    title: "8. Derechos de los titulares",
    content: [
      "El usuario podrá solicitar acceso, rectificación, actualización, eliminación u oposición al tratamiento de sus datos personales cuando corresponda conforme a la legislación vigente.",
      `Para ejercer estos derechos, podrá escribir al correo electrónico: ${COMPANY.email}.`,
    ],
  },
];

const cookiesSections = [
  {
    id: "cookies",
    title: "1. Uso de cookies",
    content: [
      "El sitio web puede utilizar cookies o tecnologías similares para mejorar la navegación, recordar preferencias, obtener métricas de uso o integrar servicios de terceros.",
      "El usuario puede configurar su navegador para bloquear o eliminar cookies. Sin embargo, algunas funciones del sitio podrían no operar correctamente si las cookies son deshabilitadas.",
    ],
  },
  {
    id: "cookies-finalidad",
    title: "2. Finalidad de las cookies",
    content: [
      "Mejorar la experiencia de navegación.",
      "Recordar preferencias básicas del usuario.",
      "Obtener métricas de uso del sitio.",
      "Integrar herramientas de terceros necesarias para formularios, analítica, mapas, soporte o comunicaciones.",
    ],
  },
];

const navItems = [
  { href: "#terminos", label: "Términos y condiciones" },
  { href: "#privacidad", label: "Política de privacidad" },
  { href: "#cookies", label: "Política de cookies" },
  { href: "#contacto-legal", label: "Contacto legal" },
];

export default function Legal() {
  return (
    <>
      <Navbar />

      <main className="relative overflow-hidden bg-white text-slate-900">
        <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(1100px_500px_at_10%_-10%,rgba(32,75,151,.12),transparent_70%),radial-gradient(900px_420px_at_100%_0%,rgba(93,131,243,.16),transparent_65%),linear-gradient(180deg,#ffffff_0%,#f8fbff_45%,#ffffff_100%)]" />

      

        <section className="relative px-4 pb-20 sm:px-6 lg:px-8">
          <div className="mx-auto grid max-w-7xl gap-8 lg:grid-cols-[280px_1fr]">
            <aside className="lg:sticky lg:top-24 lg:self-start">
              <div className="rounded-3xl border border-slate-200/70 bg-white/85 p-5 shadow-[0_20px_60px_rgba(15,23,42,.08)] backdrop-blur">
                <p className="text-sm font-bold uppercase tracking-[0.18em] text-[#204b97]">
                  Índice legal
                </p>

                <nav className="mt-5 grid gap-2">
                  {navItems.map((item) => (
                    <a
                      key={item.href}
                      href={item.href}
                      className="rounded-2xl px-4 py-3 text-sm font-medium text-slate-600 transition hover:bg-[#204b97]/5 hover:text-[#204b97]"
                    >
                      {item.label}
                    </a>
                  ))}
                </nav>

                
              </div>
            </aside>

            <div className="space-y-8">
              <LegalBlock
                id="terminos"
                eyebrow="Documento legal"
                title="Términos y Condiciones de Uso"
                description="Regulan el acceso, navegación, uso del sitio web, solicitudes comerciales, cotizaciones y contratación de servicios ofrecidos por Zentra Group."
                sections={termsSections}
              />

              <LegalBlock
                id="privacidad"
                eyebrow="Datos personales"
                title="Política de Privacidad"
                description="Explica cómo Zentra Group recopila, utiliza, almacena y protege los datos personales entregados por usuarios, clientes o contactos comerciales."
                sections={privacySections}
              />

              <LegalBlock
                id="cookies"
                eyebrow="Navegación"
                title="Política de Cookies"
                description="Información sobre el posible uso de cookies o tecnologías similares para mejorar la navegación, obtener métricas y habilitar integraciones del sitio."
                sections={cookiesSections}
              />

              <section
                id="contacto-legal"
                className="scroll-mt-28 overflow-hidden rounded-[2rem] border border-slate-200/70 bg-white shadow-[0_24px_70px_rgba(15,23,42,.10)]"
              >
                <div className="bg-[linear-gradient(135deg,#0f172a_0%,#204b97_58%,#5d83f3_100%)] p-6 text-white md:p-8">
                  <p className="text-sm font-semibold uppercase tracking-[0.2em] text-white/70">
                    Contacto legal
                  </p>

                  <h2 className="mt-3 text-3xl font-bold tracking-tight md:text-4xl">
                    Consultas, privacidad y soporte
                  </h2>

                  <p className="mt-3 max-w-2xl text-white/75">
                    Para consultas sobre términos, contratación de servicios,
                    soporte o ejercicio de derechos relacionados con datos
                    personales, puedes contactar a Zentra Group.
                  </p>
                </div>

                <div className="grid gap-4 p-6 md:grid-cols-3 md:p-8">
                  <ContactCard
                    label="Correo"
                    value={COMPANY.email}
                    href={`mailto:${COMPANY.email}`}
                  />

                  <ContactCard
                    label="Teléfono / WhatsApp"
                    value={COMPANY.phone}
                    href="tel:+56968585106"
                  />

                  <ContactCard
                    label="Sitio web"
                    value="zentragroup.cl"
                    href={COMPANY.website}
                  />
                </div>
              </section>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function InfoCard({ title, value }) {
  return (
    <div className="rounded-3xl border border-slate-200/70 bg-white/85 p-5 shadow-sm backdrop-blur">
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
        {title}
      </p>

      <p className="mt-2 font-semibold text-slate-900">{value}</p>
    </div>
  );
}

function LegalBlock({ id, eyebrow, title, description, sections }) {
  return (
    <section
      id={id}
      className="scroll-mt-28 overflow-hidden rounded-[2rem] border border-slate-200/70 bg-white shadow-[0_24px_70px_rgba(15,23,42,.10)]"
    >
      <div className="border-b border-slate-200/70 bg-slate-50/80 p-6 md:p-8">
        <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#204b97]">
          {eyebrow}
        </p>

        <h2 className="heading-display mt-3 text-3xl font-bold tracking-tight text-slate-950 md:text-5xl">
          {title}
        </h2>

        <p className="mt-4 max-w-3xl text-base leading-7 text-slate-600">
          {description}
        </p>
      </div>

      <div className="divide-y divide-slate-200/70">
        {sections.map((section) => (
          <article key={section.id} className="p-6 md:p-8">
            <h3 className="text-xl font-bold tracking-tight text-slate-900">
              {section.title}
            </h3>

            <div className="mt-4 space-y-3 text-[15px] leading-7 text-slate-600">
              {section.content.map((item, index) => (
                <p key={index} className="flex gap-3">
                  <span className="mt-[10px] h-1.5 w-1.5 shrink-0 rounded-full bg-[#204b97]" />
                  <span>{item}</span>
                </p>
              ))}
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

function ContactCard({ label, value, href }) {
  return (
    <a
      href={href}
      className="rounded-3xl border border-slate-200/70 bg-slate-50 p-5 transition hover:-translate-y-1 hover:border-[#204b97]/25 hover:bg-white hover:shadow-lg"
    >
      <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
        {label}
      </p>

      <p className="mt-2 font-semibold text-[#204b97]">{value}</p>
    </a>
  );
}